import './Menu.css'
import React, { useState } from 'react'
import Sidebar from '../../Components/SideBar/index'
import ScrollToTop from '../../Components/ScrollToTop'
import Index2 from '../../Components/Navbar2/index2'
import Footer from '../../Components/Footer/Footer'
import InfoSection3 from '../../Components/Infosection3/Index3'
import { homeObjOne3 } from '../../Components/Infosection3/Data3'

const MenuPeru = () => {
    const [isOpen, setIsOpen] = useState(false)
                  
    const toggle = () => {
    setIsOpen(!isOpen)
    }
  return (
    <>
      <ScrollToTop />
      <div className='HeroContainer_menu'>
         <Sidebar isOpen={isOpen} toggle={toggle}/>
        <div className='Hero_menu'>
           <Index2 toggle={toggle}/>
        </div>
      </div>
      <InfoSection3 {...homeObjOne3}/>
      <div className='menu_con'>
        <div className='menu_title'>
          Vår Meny
        </div>
         <div className='pris'>
          För mer info kontakta gärna 
          <br />
          076 413 08 53
          <br />
          cateringbyprestig@gmail.com
        </div>
      </div>
      <br />
      <br /><br />
      <div className='menu'>
        <div className='menu_pic'>
          <div className='grid-container'>
                  <div className='card_con'>
                    <div className='wrapper'>
                      <br /><br />
                        <div className='card_area'>
                          <div className='card'>
                            <div className='meny_title'>
                              KALLA PERUANSKA DELIKATESSER 
                            </div><br /><br />
                            <div className='menu_mat'>
                              Ceviche Clásico – vit fisk marinerad i lime, rödlök, koriander & ají.
                              <br /><br />
                                Ceviche de Camarones – räkor med lime, koriander, rödlök & chili.
                                <br /><br />
                                Causa Limeña – gul potatis med lime & ají amarillo, fylld med kycklingröra.
                                <br /><br />
                                Solterito – färgstark sallad med majs, tomat, avokado, lök & färska örter.
                                <br /><br />
                                Peruansk quinoasallad med avokado, lime & koriander.
                                <br /><br />
                                Sallad med mango, rödlök, chili & lime.
                                <br /><br />
                                Marinerade oliver & picklade grönsaker.
                            </div>
                            </div>
                            <div className='card'>
                              <div className='meny_title'>
                                PERUANSKA SMAKBITAR
                              </div><br /><br />
                              <div className='menu_mat'>
                                Empanadas Peruanas med kryddad nötfärs.
                                <br /><br />
                                Tequeños med ost & ají-sås.
                                <br /><br />
                                Krispiga kycklingbitar med peruanska kryddor.
                                <br /><br />
                                Yuca frita med ají amarillo-dipp.
                              </div> 
                            </div>              
                            <div className='card'>
                              <div className='meny_title'>
                                VARMA PERUANSKA SPECIALITETER
                              </div><br /><br />
                            <div className='menu_mat'>
                                Lomo Saltado - 
                                Wokat nötkött med tomat, rödlök, koriander & soja, serverat med peruansk potatis.
                                <br /><br />
                                Pollo a la Brasa - 
                                Peruansk grillad kyckling marinerad med vitlök, spiskummin, paprika & örter.
                                <br /><br />
                                Camarones al Ajillo - 
                                Räkor stekta med vitlök, chili, lime & färska örter.
                                <br /><br />
                                Papa a la Huancaína - 
                                Potatis med krämig gul chilissås, ost & mjölk.
                            </div>
                            </div>
                            <div className='card'>
                            <div className='meny_title'>
                              PERUANSKA TILLBEHÖR
                                </div><br /><br />
                                <div className='menu_mat'>
                                  Arroz Chaufa – peruanskt stekt ris med ägg, grönsaker & soja.
                                  <br /><br />
                                    Vitt ris med lime & färska örter.
                                    <br /><br />
                                    Rostad sötpotatis.
                                    <br /><br /> 
                                    Yuca frita.
                                    <br /><br />
                                    Grillad majs.
                                    <br /><br />
                                    Choclo – stora peruanska majskorn.
                                </div>
                                </div>
                                <div className='card'>
                              <div className='meny_title'>
                                   PERUANSKA SÅSER
                                </div><br /><br />
                                <div className='menu_mat'>
                                  Ají Amarillo.
                                  <br /><br />
                                    Ají Verde.
                                    <br /><br />
                                    Huancaína-sås.
                                    <br /><br />
                                    Rocoto-sås.
                                    <br /><br />
                                    Salsa Criolla med rödlök, lime & koriander.
                                </div>
                                </div>
                                <div className='card'>
                              <div className='meny_title'>
                                PERUANSKA DESSERTER
                        </div><br /><br />
                        <div className='menu_mat'>
                          Suspiro a la Limeña – krämig dulce de leche-dessert med maräng.
                          <br /><br />
                            Tres Leches – mjuk kaka med tre sorters mjölk.
                            <br /><br />
                            Alfajores med dulce de leche.
                            <br /><br />
                            Chokladmousse med peruansk kakao.
                            <br /><br />
                            Färsk mango, passionsfrukt & ananas.
                            <br /><br />
                        </div>
                    </div>
                  </div>             
                </div>
              </div>
            </div>
          </div>
        </div>
      <Footer />
    </>
  )
}

export default MenuPeru